export default __webpack_public_path__ + "static/media/java.a1afeb0c.svg";